<template>
<div>
<div class="classReportBox noPrintModel">
    <div class="reportPage one_page">
        <div class="noPrintModel" style="height: 30px;"></div>
        <div class="firstTit">
            <h3>{{$route.query.trainName}}</h3>
        </div>
        <div class="twoTitinfo">
            <p>
                <span>时间：{{$route.query.time}}</span>
                <span>天气：</span>
                <input class="noPrintModel editInputBgTwo" v-model="tableFrom.weather" type="text"/>
                <span style="margin-left: 20px;">地点：{{tableFrom.address}}</span>
            </p>
        </div>
        <table>
            <template v-if="showModel.state">
                <tr>
                    <td style="width: 80px;">授课老师</td>
                    <td style="min-width: 150px;">
                        <input class="noPrintModel editInputBg" v-model="tableFrom.teacherName" type="text"/>
                    </td>
                    <td style="width: 80px;">应到人数</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.ydCount" type="text"/>
                    </td>
                    <td style="width: 80px;">病假</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.bjCount" type="text"/>
                    </td>
                    <td style="width: 80px;">迟到</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.cdCount" type="text"/>
                    </td>
                    <td style="width: 80px;">旷课</td>
                    <td style="min-width: 120px;">
                        <input class="noPrintModel editInputBg" v-model="tableFrom.kkCount" type="text"/>
                    </td>
                </tr>
                <tr>
                    <td>课目</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.name" type="text"/>
                    </td>
                    <td>实到人数</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.sdCount" type="text"/>
                    </td>
                    <td>事假</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.sjCount" type="text"/>
                    </td>
                    <td>早退</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.ztCount" type="text"/>
                    </td>
                    <td>上下课时间</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.skTime" type="text"/>
                    </td>
                </tr>
                <tr>
                    <td>早上</td>
                    <td style="text-align: left;" colspan="9">
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.contents" style="min-height: 90px;padding: 6px;"></textarea>
                    </td>
                </tr>
            </template>
            <template v-if="showModel.state2">
                <tr>
                    <td style="width: 80px;">授课老师</td>
                    <td style="min-width: 150px;">
                        <input class="noPrintModel editInputBg" v-model="tableFrom.teacherName2" type="text"/>
                    </td>
                    <td style="width: 80px;">应到人数</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.ydCount2" type="text"/>
                    </td>
                    <td style="width: 80px;">病假</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.bjCount2" type="text"/>
                    </td>
                    <td style="width: 80px;">迟到</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.cdCount2" type="text"/>
                    </td>
                    <td style="width: 80px;">旷课</td>
                    <td style="min-width: 120px;">
                        <input class="noPrintModel editInputBg" v-model="tableFrom.kkCount2" type="text"/>
                    </td>
                </tr>
                <tr>
                    <td>课目</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.name2" type="text"/>
                    </td>
                    <td>实到人数</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.sdCount2" type="text"/>
                    </td>
                    <td>事假</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.sjCount2" type="text"/>
                    </td>
                    <td>早退</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.ztCount2" type="text"/>
                    </td>
                    <td>上下课时间</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.skTime2" type="text"/>
                    </td>
                </tr>
                <tr>
                    <td>上午</td>
                    <td style="text-align: left;" colspan="9">
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.contents2" style="min-height: 90px;padding: 6px;"></textarea>
                    </td>
                </tr>
            </template>
            <template v-if="showModel.state3">
                <tr>
                    <td style="width: 80px;">授课老师</td>
                    <td style="min-width: 150px;">
                        <input class="noPrintModel editInputBg" v-model="tableFrom.teacherName3" type="text"/>
                    </td>
                    <td style="width: 80px;">应到人数</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.ydCount3" type="text"/>
                    </td>
                    <td style="width: 80px;">病假</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.bjCount3" type="text"/>
                    </td>
                    <td style="width: 80px;">迟到</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.cdCount3" type="text"/>
                    </td>
                    <td style="width: 80px;">旷课</td>
                    <td style="min-width: 120px;">
                        <input class="noPrintModel editInputBg" v-model="tableFrom.kkCount3" type="text"/>
                    </td>
                </tr>
                <tr>
                    <td>课目</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.name3" type="text"/>
                    </td>
                    <td>实到人数</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.sdCount3" type="text"/>
                    </td>
                    <td>事假</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.sjCount3" type="text"/>
                    </td>
                    <td>早退</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.ztCount3" type="text"/>
                    </td>
                    <td>上下课时间</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.skTime3" type="text"/>
                    </td>
                </tr>
                <tr>
                    <td>下午</td>
                    <td style="text-align: left;" colspan="9">
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.contents3" style="min-height: 90px;padding: 6px;"></textarea>
                    </td>
                </tr>
            </template>
            <template v-if="showModel.state4">
                <tr>
                    <td style="width: 80px;">授课老师</td>
                    <td style="min-width: 150px;">
                        <input class="noPrintModel editInputBg" v-model="tableFrom.teacherName4" type="text"/>
                    </td>
                    <td style="width: 80px;">应到人数</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.ydCount4" type="text"/>
                    </td>
                    <td style="width: 80px;">病假</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.bjCount4" type="text"/>
                    </td>
                    <td style="width: 80px;">迟到</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.cdCount4" type="text"/>
                    </td>
                    <td style="width: 80px;">旷课</td>
                    <td style="min-width: 120px;">
                        <input class="noPrintModel editInputBg" v-model="tableFrom.kkCount4" type="text"/>
                    </td>
                </tr>
                <tr>
                    <td>课目</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.name4" type="text"/>
                    </td>
                    <td>实到人数</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.sdCount4" type="text"/>
                    </td>
                    <td>事假</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.sjCount4" type="text"/>
                    </td>
                    <td>早退</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.ztCount4" type="text"/>
                    </td>
                    <td>上下课时间</td>
                    <td>
                        <input class="noPrintModel editInputBg" v-model="tableFrom.skTime4" type="text"/>
                    </td>
                </tr>
                <tr>
                    <td>晚自习</td>
                    <td style="text-align: left;" colspan="9">
                        <textarea class="noPrintModel editInputBg" v-model="tableFrom.contents4" style="min-height: 90px;padding: 6px;"></textarea>
                    </td>
                </tr>
            </template>
            <tr>
                <td>情况反映</td>
                <td style="text-align: left;" colspan="9">
                    <textarea class="noPrintModel editInputBg" v-model="tableFrom.summarys" style="min-height: 90px;padding: 6px;"></textarea>
                </td>
            </tr>
        </table>

        <div class="footPlayModel noPrintModel">
            <el-button @click.prevent="toSaveFile" type="success">打印</el-button>
            <el-button @click.prevent="updateFromFun" type="primary">提交</el-button>
            <el-button @click.prevent="$router.go(-1)" type="primary">返回</el-button>
        </div>
    </div>
</div>
<classReportDaYing 
v-if="showPrint" 
ref="printDom" 
:infoFrom="tableFrom"
:showModel="showModel" 
class="printModel showPrintModel"></classReportDaYing>
</div>
</template>

<script>
import classReportDaYing from './classReportDaYing.vue';
import {
    getClassMasterLogInfoApi,
    updateClassMasterLogInfoApi
} from '@/api/personcenter/index';
export default {
    name: 'classReport',
    components:{
        classReportDaYing
    },
    data(){
        return {
            tableFrom:{},
            showPrint: false,
            showModel:{
                state: true,
                state2: true,
                state3: true,
                state4: true,
            }
        }
    },
    mounted(){
        this.getInfo();
    },
    methods:{
        //获取页面详情
        getInfo(){
            let para = {
                // userId: this.$store.state.User.ids,
                trainId: this.$route.query.trainId,
                dates: this.$route.query.time
            };
            getClassMasterLogInfoApi(para).then(res=>{
                if(res.code == 200){
                    this.tableFrom = res.result || {};
                    this.tableFrom.dates = this.$route.query.time;
                    this.tableFrom.trainId = this.$route.query.trainId;
                    this.tableFrom.trainName = this.$route.query.trainName;
                    let info = JSON.parse(this.$store.state.User.infos);
                    this.tableFrom.userId = this.$store.state.User.ids;
                    this.tableFrom.userName = info.name;

                    this.showModel = {
                        state: !!this.tableFrom.name,
                        state2: !!this.tableFrom.name2,
                        state3: !!this.tableFrom.name3,
                        state4: !!this.tableFrom.name4,
                    }
                    this.showPrint = true;
                }
            })
        },
        //去保存
        toSaveFile(){
            this.$refs.printDom.getFrom(this.tableFrom);
            this.$nextTick(()=>{
                window.print()
            })
        },
        //更新数据
        updateFromFun(){
            if((!this.tableFrom.name && this.showModel.state) 
            || (!this.tableFrom.name2 && this.showModel.state2) 
            || (!this.tableFrom.name3 && this.showModel.state3) 
            || (!this.tableFrom.name4 && this.showModel.state4)
            ){
                this.$message.warning('课目不能为空!');
                return false
            }else if((!this.tableFrom.teacherName && this.showModel.state) 
            || (!this.tableFrom.teacherName2 && this.showModel.state2) 
            || (!this.tableFrom.teacherName3 && this.showModel.state3) 
            || (!this.tableFrom.teacherName4 && this.showModel.state4)
            ){
                this.$message.warning('授课老师不能为空!');
                return false
            }
            updateClassMasterLogInfoApi(this.tableFrom).then(res=>{
                if(res.code == 200){
                    this.$message.success('提交成功');
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
h1,h2,h3{
    padding: 0px;
    margin: 0px;
}
.classReportBox{
    position: relative;
    margin: 0;
    padding: 20px 0px;
    background-color: #f2f2f2;

    .reportPage{
        width: calc(190.5mm*1.5);
        min-height: calc(247mm*1.5);
        margin: auto;
        margin-bottom: 20px;
        box-shadow: 1px 1px 8px #e2e2e2;
        background-color: #fff;
        box-sizing: border-box;
        padding: 20px 45px;
    }

    .one_page{
        .firstTit{
            width: 100%;
            text-align: center;
            padding-bottom: 10px;
            h3{
                font-family: '宋体';
                font-size: 26px;
            }
        }
        .twoTitinfo{
            text-align: left;
            font-family: '宋体';
            font-size: 16px;
            padding-bottom: 8px;

            p{
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                span + span{
                    margin-left: 10px;
                }
            }
        }
        table{
            width: 100%;
            border-collapse: collapse;
            font-family: '宋体';
            font-size: 16px;
            tr{
                text-align: center;
                th{
                    padding: 10px;
                }
                td{
                    padding: 10px 4px;
                    border: 1px solid #000;
                }
                .textCon{
                    text-align: left;
                }
            }
        }

        .footPlayModel{
            padding-top: 20px;
            text-align: right;
        }
    }
}

.showPrintModel{
    display: none;
}

.editInputBg{
    background-color: #f2f2f2;
    width: 100%;
    height: 36px;
    box-sizing: border-box;
    padding: 0px 6px;
    font-size: 16px;
    border-radius: 2px;
    border: 1px solid transparent;
    &:focus{
        border-color: #409EFF;
    }
}

.editInputBgTwo{
    display: inline-block;
    background-color: #f2f2f2;
    width: 120px;
    height: 36px;
    box-sizing: border-box;
    padding: 0px 6px;
    font-size: 16px;
    border-radius: 2px;
    border: 1px solid transparent;
    &:focus{
        border-color: #409EFF;
    }
}

@media print {
    @page {
        size: 210mm 297mm; /* or size: 794px 1123px; */
    }
    *,body,#app{
        padding: 0px;
        margin: 0px;
    }
    .classReportBox{
        background-color: #fff;
    }
    .reportPage{
        width: 190.5mm;
        min-height: 247mm;
        box-shadow: none !important;
        margin-bottom: 0px !important;
        padding: 0px !important;
    }
    .noPrintModel{
        display: none;
    }
    .showPrintModel{
        display: block;
    }
}

.printModel{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100vw;
    min-height: 100vh;
}
</style>